module.exports = __webpack_public_path__ + "img/logo-sc-blanco.f0efd89e.svg";